import React from "react";
import { Link } from "react-router-dom";

const Metalogo = () => (
  <div>
      <h3 id="logo">
        <Link to="/"><img src="https://www.metasolutions.net/wp-content/uploads/2021/04/metalogo.png" alt="META Powerschool Customization Catalog"></img></Link>
      </h3>
  </div>
);

export default Metalogo;